/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 17,
  image: "default-changelog-v2.png",
  title: "Changelog Notes - V3.2.2-beta",
  shortDescription: "This release we have made some major improvements on our compute platform like bringing monitoring to the instance. We have also fixed some important issues. We have also added some new changes in our APIs.",
  description: "This release we have made some major improvements on our compute platform like bringing monitoring to the instance. We have also fixed some important issues. We have also added some new changes in our APIs.",
  date: "Dec 8th, 2022",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Health-check", "Bonus", "CD", "Activation", "bug", "fixes", "Compute default subscription", "Instance", "Cloud", "Platform", "Compute"]
};
export const content = ` 
## Compute Improvements

- **Health Check** : We have added the ability for you to set up a health check endpoint for your cluster instances. This feature lets you monitor
  your instances and know if everything is working. All you need is to set up the path and port of your health check endpoint, and every 5
  minutes, we will send a request and check if we are getting a response; if not, the cluster instance state will be changed to Inactive.

- **Command and Arguments** : We have added support for you to set up a custom command and arguments for your cluster instances. The
  command will be executed when starting a container with the passed arguments.

- **Compute default subscription** : When you create a new compute organization, you will get 20 AKT for free, which will propagate to the next
  month until it is all used up. With the PRO subscription plan, you will get 50akt each month. The default subscription doesn’t give free AKT
  anymore.

- **Cluster Template Settings** : We have updated the settings page of the cluster instance created from a template to have the same UI as when
  creating a new instance from the template.

## Improvements

- **Coupon Activation** : From now on, you can upgrade the subscription package when activating the coupon from the coupon page.

- **Bonus bandwidth** : We have added a new bonus for bandwidth.

- **Repository search** : Removed the loader from the text input when searching,

## Fixes 🛠

- We fixed the duplicate items in the port dropdown
- **The deletion of git connections:** We have fixed the bug because it wasn’t possible to delete a git connection.
- **Cancellation button:** We have fixed the issue that would cause the cancellation button not to be displayed on the current plan page in billing.
- **Payment in progress:** We have fixed the issue that would cause the Payment in progress banner not to be displayed.
- **URL of updated cluster instance:** We have fixed the issue that was causing the URL of updated instances not to be shown.
- **Deployment stuck in the Pending / Queue state:** We have fixed the issue that caused the deployments to be in the Pending / Queue state
  for a long duration.

## API Changes

- Added a query parameter name to the \`GET: /organization/:organizationId/projects\` request, with which the projects can be
  filtered by name.

- Response of deployment endpoints updated not to include the git provider token.
  - \`POST: /deployment/\`
  - \`POST: /deployment/redeploy\`
  - \`POST: /deployment/authorize\`
    `;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
